import React from 'react';

interface BadgeProps {
    variant: 'on-track' | 'at-risk' | 'overdue' | 'info';
    children: React.ReactNode;
    icon?: React.ReactNode;
    className?: string;
}

export const Badge: React.FC<BadgeProps> = ({
    variant,
    children,
    icon,
    className = '',
}) => {
    const variants = {
        'on-track': 'bg-success-100 text-success-800 border-success-600/30',
        'at-risk': 'bg-warning-100 text-warning-800 border-warning-600/40',
        overdue: 'bg-danger-100 text-danger-800 border-danger-600/40',
        info: 'bg-blue-100 text-blue-800 border-blue-200',
    };

    return (
        <span
            className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border ${variants[variant]} ${className}`}
        >
            {icon && (
                <span className="w-3 h-3 flex-shrink-0" aria-hidden="true">
                    {icon}
                </span>
            )}
            {children}
        </span>
    );
};

